import script from "./NavigationTeacherAndParent.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationTeacherAndParent.vue?vue&type=script&setup=true&lang=js"

import "./NavigationTeacherAndParent.vue?vue&type=style&index=0&id=59a5b89d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a5b89d"]])

export default __exports__